export const TemplateModeEnum = {
  AUDIT: 'AUDIT',
  SALES: 'SALES',
  TECHNICIAN: 'TECHNICIAN',
  PARTS: 'PARTS'
} as const;

export type TemplateModeEnum = typeof TemplateModeEnum[keyof typeof TemplateModeEnum];

export const TemplateTypeEnum = {
  CUSTOM: 'CUSTOM',
  EMAIL: 'EMAIL',
  FO: 'FO',
  SMS: 'SMS'
} as const;

export type TemplateTypeEnum = typeof TemplateTypeEnum[keyof typeof TemplateTypeEnum];
